module.exports = __webpack_public_path__ + "src/assets/img/vintage Menu card.810d2372.jpg";